import { Typography, theme } from 'antd';
import { useLocale } from '@acast-tech/decibel';
import { closedHourEnd } from './localTodayHours';

const { Text } = Typography;

interface LastSyncedProps {
  lastSyncedTimeUTC?: string;
}

const LastSynced = ({ lastSyncedTimeUTC }: LastSyncedProps) => {
  const { locale } = useLocale();
  const { token } = theme.useToken();
  const bucketStart = lastSyncedTimeUTC ? new Date(lastSyncedTimeUTC) : undefined;
  const syncedAt =
    bucketStart && !Number.isNaN(bucketStart.getTime())
      ? new Date(closedHourEnd(bucketStart.getTime()))
      : undefined;
  const lastSyncedTime = syncedAt
    ? syncedAt.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
    : 'N/A';
  const timeZoneLabel = syncedAt
    ? new Intl.DateTimeFormat(locale, { timeZoneName: 'shortOffset' })
        .formatToParts(syncedAt)
        .find((part) => part.type === 'timeZoneName')?.value
    : undefined;

  return (
    <Text
      style={{
        fontSize: token.fontSizeSM,
        color: token.colorTextSecondary,
        whiteSpace: 'nowrap',
      }}
    >
      Last synced{' '}
      <Text style={{ fontSize: token.fontSizeSM, fontWeight: 700, color: token.colorText }}>
        {lastSyncedTime}
      </Text>
      {timeZoneLabel ? ` (${timeZoneLabel})` : null}
    </Text>
  );
};

export default LastSynced;
